import React from 'react';
import { InsightsPage } from './InsightsPage';

/**
 * MusclesPage is preserved as a thin wrapper so the previous PR's
 * /insights/muscles deep-link still works. The full page lives at
 * /insights (tabbed: Muscles / Calendar).
 */
export const MusclesPage = () => <InsightsPage />;
export default MusclesPage;

